import { Component } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
  imports: [TranslatePipe, MatButton],
  selector: 'app-update-snack',
  styleUrls: ['./update-snack.component.scss'],
  templateUrl: './update-snack.component.html',
  standalone: true,
})
export class UpdateSnackComponent {
  constructor(private readonly snackBarRef: MatSnackBarRef<UpdateSnackComponent>) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }

  action(): void {
    this.snackBarRef.dismissWithAction();
  }
}
